export type ContentLocaleCode = 'hr' | 'en';

export interface LocalizedStringMap {
  hr: string;
  en: string;
}

export function emptyLocalizedStringMap(): LocalizedStringMap {
  return { hr: '', en: '' };
}

export function localizedHasAnyText(m?: LocalizedStringMap | null): boolean {
  if (!m) return false;
  return m.hr.trim() !== '' || m.en.trim() !== '';
}

export function pickLocalizedDisplay(m?: LocalizedStringMap | null, legacy?: string): string {
  if (m) {
    if (m.hr.trim()) return m.hr.trim();
    if (m.en.trim()) return m.en.trim();
  }
  return (legacy ?? '').trim();
}
